import { create } from 'zustand';
import { hasPermission, type PermissionKey, type SessionUser } from '@fenix/shared';

interface AuthState {
  accessToken: string | null;
  user: SessionUser | null;
  hydrated: boolean;
  setSession: (token: string, user: SessionUser) => void;
  setUser: (user: SessionUser) => void;
  /** A API respondeu PASSWORD_CHANGE_REQUIRED: força a tela de troca de senha. */
  requirePasswordChange: () => void;
  setHydrated: () => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  hydrated: false,
  setSession: (accessToken, user) => set({ accessToken, user }),
  setUser: (user) => set({ user }),
  requirePasswordChange: () =>
    set((s) => (s.user ? { user: { ...s.user, mustChangePassword: true } } : {})),
  setHydrated: () => set({ hydrated: true }),
  logout: () => set({ accessToken: null, user: null }),
}));

/** `true` se o usuário logado tem todas as permissões informadas (`admin` sempre tem). */
export function useCan(...keys: PermissionKey[]): boolean {
  return useAuthStore((s) => hasPermission(s.user, ...keys));
}
